import Select from '../../../app/common/components/select/Select';
import {SetFieldValue} from '../../../app/types/Forms';
import {useEffect} from "react";
import {Site} from "../Types/type";
import {useGetSites} from "../Hooks/SitesManager";

interface SelectSiteProps {
  name?: string;
  value?: Site;
  setFieldValue: SetFieldValue;
  isDisabled?: boolean;
  touched?: boolean;
  system?: string;
  error?: string;
  defaultValue?: string | null;
}

const SelectSite = ({
                      name,
                      value,
                      setFieldValue,
                      touched,
                      isDisabled,
                      error,
                      defaultValue
                    }: SelectSiteProps): JSX.Element => {
  const {isLoading, data: sites} = useGetSites();


  useEffect(() => {
    if (defaultValue && sites) {
      setFieldValue('site', sites.find(site => site.id === Number(defaultValue)));
    }
  }, [sites, defaultValue, setFieldValue])

  return (
    <Select<Site>
      label={'Site'}
      isDisabled={isDisabled}
      isLoading={isLoading}
      isClearable={true}
      isSearchable={true}
      name={name}
      onChange={(site) => {
        setFieldValue('site', site);
      }}
      value={value}
      getOptionLabel={(site) => `${site.id} - ${site.name}`}
      getOptionValue={(site) =>  site.id.toString()}
      options={sites}
      placeholder={'Veuillez sélectionner un site'}
      touched={touched}
      error={error}
      isMulti={false}
    />
  );
};

export default SelectSite;
